import { useState, useContext } from "react";
import { SMContext } from "context/smContext";
import { Typography, Tooltip, Button, Checkbox } from "@mui/material";
import {
  ArrowBack,
  LockOpen,
  Lock,
  SyncAlt,
  ArrowForward,
} from "@mui/icons-material";
import Divider10 from "components/Divider10";
import DivExist from "components/DivExist";
import DivInline from "components/DivInline";
import LightIcon from "components/LightIcon";
import Lightswitch from "asset/svgComp/Lightswitch";
import DivCol from "components/DivCol";
import DivSpaceBetween from "components/DivSpaceBetween";
import SpaceBetweenCheckbox from "components/SpaceBetweenCheckbox";
import AdminContainer from "components/AdminContainer";
import ModalSM from "components/ModalSM";
import SpaceBetweenDiv from "components/SpaceBetweenDiv";
import ChangeLockLvLightSwModal from "./ChangeLockLvLightSwModal";
import LockIcon from "components/LockIcon";
import DeviceIdAddGwLine from "components/DeviceIdAddGwLine";
import DeviceGroupActionModal from "containers/zoneCtl/DeviceGroupActionModal";
import DeviceActionLine from "components/DeviceActionLine";

export default function ControlDevicesLightSwPanel({ show }) {
  const [state, dispatch] = useContext(SMContext);
  const { activeSensorID, sensorObjAll } = state;

  const sensorObj = sensorObjAll[activeSensorID];
  const { gang } = sensorObj || {};

  return (
    <DivExist show={show}>
      <DivCol>
        <Typography variant="h6" align="center">
          Control Devices
        </Typography>
        <Divider10 />
        <ButtonGroup buttonNo={1} />
        <Divider10 />
        <DivExist show={gang > 1}>
          <ButtonGroup buttonNo={2} />
          <Divider10 />
        </DivExist>
        <DivExist show={gang > 2}>
          <ButtonGroup buttonNo={3} />
        </DivExist>
      </DivCol>
    </DivExist>
  );
}

function ButtonGroup({ buttonNo }) {
  const [state] = useContext(SMContext);
  const { activeSensorID, lightObjAll, sensorObjAll } = state;
  const sensorObj = sensorObjAll[activeSensorID];
  const { serialMap } = sensorObj || {};
  const setNo = buttonNo * 2 - 1;
  const setting = sensorObj[`setting${setNo}`];
  // const lockLevelSetON = sensorObj[`lockLevelSet${setNo + 1}`];
  // const lockLevelSetOFF = sensorObj[`lockLevelSet${setNo}`];
  let lightArr = Object.values(serialMap || {})
    .filter((s) => (setting?.[s] ? true : false))
    .sort((a, b) => a.localeCompare(b));
  return (
    <div style={{ width: "100%" }}>
      <DivInline justifyContent="space-between">
        <Typography>Switch {buttonNo}</Typography>

        <Typography variant="caption">Priority Level</Typography>
        <ChangeLockLvLightSwModal swNo={buttonNo} sensorObj={sensorObj} />
      </DivInline>
      <Divider10 />
      {lightArr.map((s) => {
        return (
          <div key={s}>
            <LightRow
              serial={s}
              lightObj={lightObjAll[s]}
              settingNum={setNo}
              sensorObj={sensorObj}
              buttonNo={buttonNo}
            />
          </div>
        );
      })}
      <DivExist show={lightArr.length === 0}>
        <Typography variant="caption" align="center">
          No light connected
        </Typography>
      </DivExist>
    </div>
  );
}

function LightRow({ serial, lightObj, settingNum, sensorObj, buttonNo }) {
  const lightStyle = lightObj?.style;
  const isDim = lightObj?.type?.pwm;
  const settingOff = sensorObj[`setting${settingNum}`]; //example setting1, setting3, setting5
  const serialSettingOff = settingOff?.[serial] || {};
  const currentOnoffcontrolA_off = serialSettingOff?.onoffcontrolA ?? 1;
  const currentPwm_off = serialSettingOff?.pwm ?? 0;
  const lockLevelOff = serialSettingOff?.lockLevel;
  const settingOn = sensorObj[`setting${settingNum + 1}`]; //example setting2, setting4, setting6
  const serialSettingOn = settingOn?.[serial] || {};
  const currentOnoffcontrolA_on = serialSettingOn?.onoffcontrolA ?? 1;
  const currentPwm_on = serialSettingOn?.pwm ?? 0;
  const lockLevelOn = serialSettingOn?.lockLevel ?? 5;
  const releaseOnEnd = serialSettingOff?.releaseOnDelayEnd ?? 0;
  return (
    <div>
      <Typography>{lightObj?.description}</Typography>
      <DivInline >
        <DeviceIdAddGwLine deviceID={serial} address={serialSettingOn.dtkAdd} gatewayID={serialSettingOn.gatewayID} />
        <DeviceGroupActionModal deviceObj={sensorObj} lightObj={lightObj} settingNumArray={[settingNum, settingNum + 1]} />
      </DivInline>
      <DeviceActionLine deviceSetting={serialSettingOff} deviceSetting2={serialSettingOn} deviceObj={lightObj} mainDeviceObj={sensorObj} buttonNo={buttonNo} />
      {/* <DivInline justifyContent="space-between" sx={{ width: "100%" }}>
          <LockIcon lockLevel={lockLevelOn} size="1rem" />
          <Lightswitch
            status={1}
            status2={1}
            status3={1}
            status4={1}
            width={3}
            sizeUnit="vw"
            disabledConnectStatus
            disabledStatus={settingNum === 3 || settingNum === 5}
            disabledStatus2={settingNum === 1 || settingNum === 5}
            disabledStatus3={settingNum === 1 || settingNum === 3}
            gang={sensorObj.gang}
          />
          <LightIcon
            statusA={currentOnoffcontrolA_on}
            lightStyle={lightStyle}
            lightLv={
              isDim && currentOnoffcontrolA_on === 0 ? currentPwm_on : 100
            }
            width={2.5}
            sizeUnit="vw"
            disabledConnectStatus
          />
          {isDim && currentOnoffcontrolA_on === 0 && (
            <Typography>{currentPwm_on}%</Typography>
          )}

          <SyncAlt sx={{ margin: "0.5vw" }} />
          <Lightswitch
            status={0}
            status2={0}
            status3={0}
            status4={0}
            width={2.5}
            sizeUnit="vw"
            disabledConnectStatus
            disabledStatus={settingNum === 3 || settingNum === 5}
            disabledStatus2={settingNum === 1 || settingNum === 5}
            disabledStatus3={settingNum === 1 || settingNum === 3}
            gang={sensorObj.gang}
          />

          <LightIcon
            statusA={currentOnoffcontrolA_off}
            lightStyle={lightStyle}
            lightLv={
              isDim && currentOnoffcontrolA_off === 0 ? currentPwm_off : 100
            }
            width={2}
            sizeUnit="vw"
            disabledConnectStatus
          />

          {isDim && currentOnoffcontrolA_off === 0 && (
            <Typography>{currentPwm_off}%</Typography>
          )}
          <LockIcon
            lockLevel={releaseOnEnd === 1 ? 5 : lockLevelOn}
            size="1rem"
          />
        </DivInline> */}

    </div>
  );
}

